import store from '../store';

export default () => store('access_token') || store('auth_token');
